<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > <strong> VISITOR ID : {{ form.id }}  </strong> </label>
             
             <CRow class="mt-3">
    
               <CCol>
                 <label> {{ "Name: " + form.firstname + ' ' + form.lastname }} </label>
               </CCol>
                 </CRow>
             <hr>
              <CRow>
                <CCol><label> {{ "Email: " + form.email }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "DOB: " + form.dob }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "Mobile: " + form.mobile }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow>
                <CCol><label> {{ "Address: " + form.address1 }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow v-for="item in icare" :key="item.id">
                <CCol>
                  <label > {{ "Pernah ke Icare: " + item.icare.name}} </label>
                </CCol>
                </CRow>
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Close</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>

import EventBus from '@/eventBus';
import visitor from '@/services/visitor'

export default {
name: 'visitormodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      icare: [],
      form:{
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        dob: '',
        address1: '',
        address2: '',
        mobile:'',
      }
    }
  },
   computed: {

   },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_VISITOR', (params) => {
      if(params.data){
        visitor.getVisitorbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.email = res.data.email;
          self.form.dob = res.data.dob;
          self.form.mobile = res.data.mobile;
          self.form.address1 = res.data.address1 + " " + res.data.address2;
          self.icare = res.icare;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
  }
}
</script>
